module.exports = __webpack_public_path__ + "img/camera_ok.448a4157.svg";